import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";

export const Route = createFileRoute("/_authenticated/admin/kateqoriyalar")({
  component: Page,
});

function Page() {
  return (
    <div>
      <AdminPageHeader
        title="Kateqoriyalar"
        description="Kateqoriya və alt kateqoriyaları idarə et"
      />
      <CrudManager
        table="categories"
        orderColumn="sort_order"
        ascending
        addLabel="Yeni kateqoriya"
        emptyText="Kateqoriya yoxdur."
        fields={[
          { name: "name", label: "Ad" },
          { name: "slug", label: "Qısa ünvan (slug)" },
          { name: "icon", label: "İkon adı", placeholder: "Home, Car, Smartphone…" },
          { name: "parent_slug", label: "Əsas kateqoriya (slug)", placeholder: "boş = əsas kateqoriya" },
          { name: "sort_order", label: "Sıra", type: "number" },
          { name: "active", label: "Aktiv", type: "boolean" },
        ]}
        columns={[
          { name: "name", label: "Ad" },
          { name: "slug", label: "Slug" },
          { name: "parent_slug", label: "Əsas kateqoriya" },
          { name: "sort_order", label: "Sıra" },
          { name: "active", label: "Vəziyyət", render: (r) => (r["active"] ? "Aktiv" : "Deaktiv") },
        ]}
      />
    </div>
  );
}
